var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RecentEventsModal',{attrs:{"open":_vm.showRecentEventsModal,"recentEvents":_vm.recentEvents.data.value.recent_events},on:{"update:open":function($event){_vm.showRecentEventsModal=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }